import { CustomBookingMethod } from '~api/config';

import { DetailsDrawer as Drawer } from '~src/components/DetailsDrawer/DetailsDrawer';

import { StepList } from '../details/step-list';

interface Props {
  item: CustomBookingMethod | undefined;
}

export function DetailsDrawer({ item }: Props) {
  return (
    <Drawer
      detailsHref={item?.method}
      title={item?.method}
      nodes={[
        <Drawer.Plain label="common.shippingMethod" value={item?.method} key="shipping-method" />,
        <StepList steps={item?.steps ?? []} key="steps" />,
      ]}
    />
  );
}
